import React, {useContext, useEffect, useRef, useState} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import { Basket } from "../../context/basket";
import {Sons} from "../../context/theme";
import Renderer from "../../customiser/components/products/item/renderer"
import addToBasket from "../../customiser/components/products/model/actions/add";

const Upsales = (props) =>
{
    const basket = useContext(Basket);
    const data = useContext(Sons);
    const [inBasketItems, setInBasketItems] = useState([]);
    const [activeProducts, setActiveProducts] = useState([]);
    const [shouldGreyOut, setShouldGreyOut] = useState([]);
    const [initialItems, setInitialItems] = useState([]);

    useEffect(() => {
        if (basket?.data?.quote?.quote
            && data?.length > 0
            && typeof data[0].id !== 'undefined'
            && JSON.stringify(initialItems.sort()) === JSON.stringify(inBasketItems.sort())
        ) {
            const activeBasketItems = inBasketItems.sort();
            const basketItems = basket?.data?.quote?.quote?.items.map((item) => {
                return item.product_id;
            }).sort();
            if (JSON.stringify(basketItems) !== JSON.stringify(activeBasketItems)) {
                setInBasketItems(basketItems);
                setActiveProducts(basketItems);
                setInitialItems(basketItems);
            }
            if (props.loader) {
                props.setLoader(false);
            }
        } else if (JSON.stringify(initialItems.sort()) !== JSON.stringify(inBasketItems.sort())
            && props.loader === false) {
            const typeOfUpdate = (inBasketItems.length < initialItems.length) ? 'Removing' : 'Adding';
            props.setLoader(true);
            props.setLoadingMessage(typeOfUpdate + ' item to your basket...');
            addToBasket(activeProducts, false, true).then(response => {
                basket.updateBasketReturn().then(basketResponse => {
                    setInitialItems(activeProducts);
                    props.setLoader(false);
                });
            });
        }

    }, [basket?.data, data, inBasketItems]);

    return (
        <div className="swiper-wrapper" style={{display: 'block'}}>
            {!props.loader && (
                <Swiper
                    slidesPerView={1}
                    spaceBetween={10}
                    pagination={{
                        clickable: true
                    }}
                    navigation={true}
                    breakpoints={{
                        450: {
                            slidesPerView: 1,
                            spaceBetween: 0,
                        },
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 15,
                        },
                        992: {
                            slidesPerView: 2,
                            spaceBetween: 40,
                        },
                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 45,
                        },
                        1400: {
                            slidesPerView: 3,
                            spaceBetween: 45,
                        },
                        1600: {
                            slidesPerView: 3,
                            spaceBetween: 45,
                        }
                    }}
                    modules={[Pagination, Navigation]}
                    className="items-container"
                >
                    <div className="items-wrapper">
                        {data?.length > 0
                            && typeof basket?.data?.quote !== 'undefined'
                            && typeof data[0].id !== 'undefined'
                            && data.map((item) => {
                                let crossSellChild = null;
                                if (typeof item.parent_item_id === 'undefined'
                                    && typeof item.child_skus !== 'undefined') {
                                    const childSkus = JSON.parse(item.child_skus);
                                    for (let i = 0; i < data.length; i++) {
                                        let loopProduct = data[i];
                                        if (childSkus.indexOf(loopProduct.sku) !== -1) {
                                            crossSellChild = loopProduct;
                                        }
                                    }
                                } else if (item.parent_item_id !== 'undefined') {
                                    return false;
                                }
                                return (
                                    <SwiperSlide key={'swiper-basket-' + item.sku}>
                                        <Renderer
                                            product={item}
                                            inBasketItems={inBasketItems}
                                            setInBasketItems={setInBasketItems}
                                            activeProducts={activeProducts}
                                            setActiveProducts={setActiveProducts}
                                            shouldGreyOut={shouldGreyOut}
                                            setShouldGreyOut={setShouldGreyOut}
                                            addToCartTitle={'Add Product to Basket'}
                                            oneOffItem={true}
                                            shouldShowPrice={true}
                                            crossSellChild={crossSellChild}
                                            key={'basket-item-' + item.sku}
                                        />
                                    </SwiperSlide>
                                )
                            })
                        }
                    </div>
                </Swiper>
            )}
        </div>
    );
}

export default Upsales;
